import { jsx as _jsx } from "react/jsx-runtime";
import { DeliveryOptionsEnum } from '@as-react/common-types';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Banner } from '@yonderland/andes-react';
import { useDeliveryState } from '../../../context/CheckoutDeliveryContext';
export const CollectHQContainer = () => {
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.general]);
    const [state] = useDeliveryState();
    const { activeDeliveryOption } = state;
    return activeDeliveryOption &&
        activeDeliveryOption.name === DeliveryOptionsEnum.COLLECT_HQ &&
        Boolean(state.errors[activeDeliveryOption.name]) ? (_jsx(Banner, { text: t(state.errors[activeDeliveryOption.name]), status: "error" })) : null;
};
